var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefrigerator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.8 31.4c0 .6-.5 1.1-1.1 1.1H15.6c-.6 0-1.1-.5-1.1-1.1V8.6c0-.6.5-1.1 1.1-1.1h10.1c.6 0 1.1.5 1.1 1.1zM26.8 15.8H14.5M17.5 10.9v3.4M17.5 17.6v3.5"
}))));
export default SvgRefrigerator;